import React from "react";
import { useTranslation } from "react-i18next";
import { generateSlug } from "../../../../utils/slugUtils";
import {
  useNavigationStyles,
  NavigationLink,
  NavigationButton,
  MobileDropdownIcon,
} from "../../NavigationStyles";
import {
  translateProductItem,
  translateMagazineItem,
  getMagazineItemPath,
  translateBusinessItem,
  getBusinessItemPath,
  translateCompanyItem,
  getCompanyItemPath,
  translateAIServiceItem,
} from "./translationMappings";

// Mobile Products Dropdown Component
export const MobileProductsDropdown = ({
  productItems,
  isOpen,
  setIsOpen,
  closeMobileMenu,
}) => {
  const { t } = useTranslation("common");
  const { getMobileDropdownVisibility } = useNavigationStyles();

  const handleProductClick = () => {
    setIsOpen(false);
    closeMobileMenu();
  };

  return (
    <div>
      <NavigationButton
        variant="mobile-button"
        onClick={() => setIsOpen(!isOpen)}
        showIcon={true}
        iconComponent={<MobileDropdownIcon isOpen={isOpen} />}
      >
        {t("navigation.products")}
      </NavigationButton>

      <div className={getMobileDropdownVisibility(isOpen)}>
        <NavigationLink
          to="/products"
          variant="mobile-dropdown"
          onClick={handleProductClick}
        >
          {t("navigation.products")}
        </NavigationLink>
        {productItems.map((item, index) => (
          <NavigationLink
            key={index}
            to={`/products/${generateSlug(item)}`}
            variant="mobile-dropdown"
            onClick={handleProductClick}
          >
            {translateProductItem(item, t)}
          </NavigationLink>
        ))}
      </div>
    </div>
  );
};

// Mobile Magazine Dropdown Component
export const MobileMagazineDropdown = ({
  magazineItems,
  isOpen,
  setIsOpen,
  closeMobileMenu,
}) => {
  const { t } = useTranslation("common");
  const { getMobileDropdownVisibility } = useNavigationStyles();

  const handleMagazineClick = () => {
    setIsOpen(false);
    closeMobileMenu();
  };

  return (
    <div>
      <NavigationButton
        variant="mobile-button"
        onClick={() => setIsOpen(!isOpen)}
        showIcon={true}
        iconComponent={<MobileDropdownIcon isOpen={isOpen} />}
      >
        {t("navigation.magazine")}
      </NavigationButton>

      <div className={getMobileDropdownVisibility(isOpen)}>
        <NavigationLink
          to="/magazine"
          variant="mobile-dropdown"
          onClick={handleMagazineClick}
        >
          {t("navigation.magazine")}
        </NavigationLink>
        {magazineItems.map((item, index) => (
          <NavigationLink
            key={index}
            to={getMagazineItemPath(item)}
            variant="mobile-dropdown"
            onClick={handleMagazineClick}
          >
            {translateMagazineItem(item, t)}
          </NavigationLink>
        ))}
      </div>
    </div>
  );
};

// Mobile Business Dropdown Component
export const MobileBusinessDropdown = ({
  businessItems,
  isOpen,
  setIsOpen,
  closeMobileMenu,
}) => {
  const { t } = useTranslation("common");
  const { getMobileDropdownVisibility } = useNavigationStyles();

  const handleBusinessClick = () => {
    setIsOpen(false);
    closeMobileMenu();
  };

  return (
    <div>
      <NavigationButton
        variant="mobile-button"
        onClick={() => setIsOpen(!isOpen)}
        showIcon={true}
        iconComponent={<MobileDropdownIcon isOpen={isOpen} />}
      >
        {t("navigation.business")}
      </NavigationButton>

      <div className={getMobileDropdownVisibility(isOpen)}>
        {businessItems.map((item, index) => (
          <NavigationLink
            key={index}
            to={getBusinessItemPath(item)}
            variant="mobile-dropdown"
            onClick={handleBusinessClick}
          >
            {translateBusinessItem(item, t)}
          </NavigationLink>
        ))}
      </div>
    </div>
  );
};

// Mobile Company Dropdown Component
export const MobileCompanyDropdown = ({
  companyItems,
  isOpen,
  setIsOpen,
  closeMobileMenu,
}) => {
  const { t } = useTranslation("common");
  const { getMobileDropdownVisibility } = useNavigationStyles();

  const handleCompanyClick = () => {
    setIsOpen(false);
    closeMobileMenu();
  };

  return (
    <div>
      <NavigationButton
        variant="mobile-button"
        onClick={() => setIsOpen(!isOpen)}
        showIcon={true}
        iconComponent={<MobileDropdownIcon isOpen={isOpen} />}
      >
        {t("navigation.company")}
      </NavigationButton>

      <div className={getMobileDropdownVisibility(isOpen)}>
        {companyItems.map((item, index) => (
          <NavigationLink
            key={index}
            to={getCompanyItemPath(item)}
            variant="mobile-dropdown"
            onClick={handleCompanyClick}
          >
            {translateCompanyItem(item, t)}
          </NavigationLink>
        ))}
      </div>
    </div>
  );
};

// Mobile AI Services Dropdown Component
export const MobileAIServicesDropdown = ({
  aiServicesItems,
  isOpen,
  setIsOpen,
  closeMobileMenu,
}) => {
  const { t } = useTranslation("common");
  const { getMobileDropdownVisibility } = useNavigationStyles();

  const handleAIServicesClick = () => {
    setIsOpen(false);
    closeMobileMenu();
  };

  return (
    <div>
      <NavigationButton
        variant="mobile-button"
        onClick={() => setIsOpen(!isOpen)}
        showIcon={true}
        iconComponent={<MobileDropdownIcon isOpen={isOpen} />}
      >
        {t("navigation.aiServices")}
      </NavigationButton>

      <div className={getMobileDropdownVisibility(isOpen)}>
        <NavigationLink
          to="/ai-services"
          variant="mobile-dropdown"
          onClick={handleAIServicesClick}
        >
          {t("navigation.aiServices")}
        </NavigationLink>
        {aiServicesItems.map((item, index) => (
          <NavigationLink
            key={index}
            to={`/ai-services/${generateSlug(item)}`}
            variant="mobile-dropdown"
            onClick={handleAIServicesClick}
          >
            {translateAIServiceItem(item, t)}
          </NavigationLink>
        ))}
      </div>
    </div>
  );
};
